
import { CharacterHero } from "./CharacterHero";
import { CharacterInfo } from "./CharacterInfo";
import { CharacterBreadcrumbs } from "./CharacterBreadcrumbs";
import { CharacterBackButton } from "./CharacterBackButton";
import { CharacterCallToAction } from "./CharacterCallToAction";

interface Character {
  id: string;
  name: string;
  species: string;
  role: string;
  description: string;
  personality: string;
  teaching_focus: string;
  special_talents: string;
  fun_facts: any;
  image_url: string;
  avatar_url: string;
  color_theme: string;
  age_group: string;
  featured: boolean;
}

interface CharacterDetailContentProps {
  character: Character;
}

export const CharacterDetailContent = ({ character }: CharacterDetailContentProps) => {
  return (
    <>
      {/* Hero Section */}
      <CharacterHero character={character} />

      {/* Content Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-8">
        {/* Breadcrumb Navigation */}
        <CharacterBreadcrumbs characterName={character.name} />

        {/* Back Button */}
        <CharacterBackButton />

        {/* Character Information */}
        <CharacterInfo character={character} />

        {/* Call to Action */}
        <CharacterCallToAction character={character} />
      </div>
    </>
  );
};
